export const countryFallbacks = {
    AL: {latitude: 41.3275, longitude: 19.8189}, // Tirana, Albania
    AT: {latitude: 48.2082, longitude: 16.3738}, // Vienna, Austria
    BE: {latitude: 50.8503, longitude: 4.3517}, // Brussels, Belgium
    BG: {latitude: 42.6975, longitude: 23.3242}, // Sofia, Bulgaria
    CH: {latitude: 46.9481, longitude: 7.4474}, // Bern, Switzerland
    CY: {latitude: 35.1856, longitude: 33.3823}, // Nicosia, Cyprus
    CZ: {latitude: 50.0755, longitude: 14.4378}, // Prague, Czech Republic
    DE: {latitude: 52.52, longitude: 13.405}, // Berlin, Germany
    DK: {latitude: 55.6761, longitude: 12.5683}, // Copenhagen, Denmark
    EE: {latitude: 59.437, longitude: 24.7536}, // Tallinn, Estonia
    ES: {latitude: 40.4168, longitude: -3.7038}, // Madrid, Spain
    FI: {latitude: 60.1695, longitude: 24.9354}, // Helsinki, Finland
    FR: {latitude: 48.8566, longitude: 2.3522}, // Paris, France
    GR: {latitude: 37.9838, longitude: 23.7275}, // Athens, Greece
    HR: {latitude: 45.815, longitude: 15.9819}, // Zagreb, Croatia
    HU: {latitude: 47.4979, longitude: 19.0402}, // Budapest, Hungary
    IE: {latitude: 53.3498, longitude: -6.2603}, // Dublin, Ireland
    IS: {latitude: 64.1355, longitude: -21.8954}, // Reykjavik, Iceland
    IT: {latitude: 41.9028, longitude: 12.4964}, // Rome, Italy
    LT: {latitude: 54.6872, longitude: 25.2797}, // Vilnius, Lithuania
    LU: {latitude: 49.6117, longitude: 6.1319}, // Luxembourg, Luxembourg
    LV: {latitude: 56.9496, longitude: 24.1052}, // Riga, Latvia
    MT: {latitude: 35.8997, longitude: 14.5146}, // Valletta, Malta
    NL: {latitude: 52.3676, longitude: 4.9041}, // Amsterdam, Netherlands
    NO: {latitude: 59.9139, longitude: 10.7522}, // Oslo, Norway
    PL: {latitude: 52.2297, longitude: 21.0122}, // Warsaw, Poland
    PT: {latitude: 38.7169, longitude: -9.1399}, // Lisbon, Portugal
    RO: {latitude: 44.4268, longitude: 26.1025}, // Bucharest, Romania
    SE: {latitude: 59.3293, longitude: 18.0686}, // Stockholm, Sweden
    SI: {latitude: 46.0569, longitude: 14.5058}, // Ljubljana, Slovenia
    SK: {latitude: 48.1486, longitude: 17.1077}, // Bratislava, Slovakia
    UK: {latitude: 51.5072, longitude: -0.1276}, // London, United Kingdom
    US: {latitude: 37.7749, longitude: -122.4194}, // San Francisco, USA (extra)
}

export const getFallbackCoordinates = (countryCode) => {
    return countryFallbacks[countryCode] || countryFallbacks['IT'] // Default: Italia
}

export const generateGoogleMapsLinkFromAddress = (storeName, address) => {
    const query = encodeURIComponent(`${storeName}, ${address}`)
    return `https://www.google.com/maps/search/?api=1&query=${query}`
}
